import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52111d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }

import { DocumentData } from 'firebase/firestore'
import { computed, defineAsyncComponent, PropType, ref } from 'vue'
import * as moment from 'moment-timezone'
import SvgIcon from '../common/SvgIcon.vue'
import { downloadFile } from '@/helpers/link.helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'Message',
  props: {
  msg: {
    type: Object as PropType<DocumentData>,
    default: () => {
      return {}
    },
  },
  isMySelf: {
    type: Boolean,
    default: false,
  },
  isSending: {
    type: Boolean,
    default: false,
  },
},
  emits: ['unsend'],
  setup(__props, { emit: __emit }) {

const FileMessage = defineAsyncComponent(() => import('@/components/chatbox/FileMessage.vue'))
const ImageMessage = defineAsyncComponent(() => import('@/components/chatbox/ImageMessage.vue'))
const TextMessage = defineAsyncComponent(() => import('@/components/chatbox/TextMessage.vue'))

const props = __props
const emit = __emit

const isHoverMessage = ref(false)
const messageType = computed(() => {
  if (props.msg.type === 'file') return 'file'
  else if (props.msg.type === 'image') return 'image'
  else return 'text'
})
const messageComponent = computed(() => {
  if (messageType.value === 'file') return FileMessage
  else if (messageType.value === 'image') return ImageMessage
  else return TextMessage
})

const timeFormat = (seconds: number) => {
  // const tz = currentUser.value?.timezone || 'Asia/Bangkok'
  const tz = moment.tz.guess()
  return moment.tz(seconds * 1000, tz).format('h:mm A')
}

const unsendMessage = () => {
  emit('unsend')
}

const downloadImage = () => downloadFile(props.msg.message, props.msg.file_url)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message", [__props.isMySelf && 'my-self']]),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHoverMessage.value = false))
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(messageComponent.value), {
      url: __props.msg.file_url,
      message: __props.msg.message,
      class: _normalizeClass(["content", [messageType.value === 'image' && 'img-content', __props.isSending && '-loading']]),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoverMessage.value = true))
    }, null, 40, ["url", "message", "class"])),
    _createElementVNode("div", {
      class: _normalizeClass(["message-detail", [isHoverMessage.value && __props.isMySelf && 'hidden']])
    }, [
      (messageType.value === 'image')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "download-img _pointer-on-hover",
            onClick: downloadImage
          }, [
            _createVNode(SvgIcon, {
              icon: "download",
              height: "20",
              "inherit-fill": ""
            })
          ]))
        : _createCommentVNode("", true),
      (__props.isMySelf && __props.msg.read_by && __props.msg.read_by.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Read " + _toDisplayString(__props.msg.read_by.length), 1))
        : _createCommentVNode("", true),
      (__props.msg.sent_at?.seconds)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(timeFormat(__props.msg.sent_at?.seconds)), 1))
        : _createCommentVNode("", true)
    ], 2),
    (__props.isMySelf)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["unsend-msg", [isHoverMessage.value && 'show-unsend']])
        }, [
          (messageType.value === 'image')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "download-img _pointer-on-hover",
                onClick: downloadImage
              }, [
                _createVNode(SvgIcon, {
                  icon: "download",
                  height: "20",
                  "inherit-fill": ""
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", { onClick: unsendMessage }, "Unsend")
        ], 2))
      : _createCommentVNode("", true)
  ], 34))
}
}

})